export const STATUSES = [
    'APPLIED',
    'INTERVIEW_1',
    'INTERVIEW_2',
    'INTERVIEW_3',
    'TECHNICAL_TASK_1',
    'TECHNICAL_TASK_2',
    'OFFER',
    'REJECTED',
    'ARCHIVED',
    'ACTIVE',
    'INACTIVE',
];
